import { useCallback, useEffect, useRef } from 'react';
import { useFormLoadObserver } from './useFormLoadObserver';
import { useFormThemeStyles } from './useFormThemeStyles';
import { getFormsDomain, injectScript } from './formScript';
import { jsx as _jsx } from "react/jsx-runtime";
export function VersionTwoForm({
  formId,
  portalId,
  env,
  region,
  dispatch
}) {
  const containerRef = useRef(null);
  const themeStyles = useFormThemeStyles();
  const handleScriptError = useCallback(() => dispatch('onFormLoadError'), [dispatch]);
  useEffect(() => {
    injectScript(`//js.${getFormsDomain(env)}/forms/embed/developer/${portalId}.js`, undefined, handleScriptError);
  }, [portalId, env, handleScriptError]);
  const handleReady = useCallback(() => dispatch('onFormReady'), [dispatch]);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    return () => {
      // Clear embed state so the script treats the container as fresh on re-mount
      delete container.dataset.loaded;
      delete container.dataset.fetched;
      container.innerHTML = '';
    };
  }, [formId, portalId, env]);
  useFormLoadObserver(containerRef, handleReady, [formId, portalId, env, handleReady]);
  useEffect(() => {
    const handleSubmitted = e => {
      const detail = e.detail;
      if (detail.formId === formId) {
        dispatch('onFormSubmitted');
      }
    };
    window.addEventListener('hs-form-event:on-submission:success', handleSubmitted);
    return () => window.removeEventListener('hs-form-event:on-submission:success', handleSubmitted);
  }, [formId, dispatch]);
  return /*#__PURE__*/_jsx("div", {
    ref: containerRef,
    className: "hs-form-html",
    style: themeStyles,
    "data-form-id": formId,
    "data-portal-id": portalId,
    "data-region": region,
    "data-env": env
  });
}